import { createActionCreator } from "common/ReduxUtils";
import { LotInformationFormValues } from "inbounds/steps/lot-information/types/LotInformationFormValues";
import { StorageInboundLotInformationAction } from "../StorageInboundLotInformationAction.types";

export const setStorageInboundLotInformation = createActionCreator<LotInformationFormValues>(
  StorageInboundLotInformationAction.SET_STORAGE_INBOUND_LOT_INFORMATION,
  "selectedProductsLotInformation"
);
